import fetchWithAuth from '../middlewares/fetchWithAuth';
import { API_BASE_URL } from '../config';

export const DASHBOARD_V2_ENABLED = process.env.REACT_APP_DASHBOARD_V2_ENABLED !== 'false';

const request = async (path, options = {}) => {
  const response = await fetchWithAuth(`${API_BASE_URL}/dashboard${path}`, options);
  const body = await response.json();
  if (!response.ok) {
    const error = new Error(body.error || body.message || 'Dashboard request failed');
    error.status = response.status;
    error.code = body.code;
    throw error;
  }
  return body;
};

export const getDashboardPreferences = (signal) => request('/preferences', { signal });

export const saveDashboardPreferences = (preferences, revision) => request('/preferences', {
  method: 'PUT',
  headers: {
    'Content-Type': 'application/json',
    ...(revision ? { 'If-Match': revision } : {}),
  },
  body: JSON.stringify(preferences),
});

export const searchDashboardTeams = (season, text, signal) => request(
  `/teams?${new URLSearchParams({ idTemporada: season, q: text })}`,
  { signal }
);

export const getDashboardGroupTeams = ({ idTemporada, idCompeticion, idGrupo }, signal) => request(
  `/teams?${new URLSearchParams({ idTemporada, idCompeticion, idGrupo })}`,
  { signal }
);

export const getDashboardOverview = (favorite, signal) => {
  const params = new URLSearchParams({ mode: favorite ? 'team' : 'general' });
  if (favorite) {
    ['idEquipo', 'idTemporada', 'idCompeticion', 'idGrupo'].forEach((field) =>
      params.set(field, String(favorite[field]))
    );
  }
  return request(`/overview?${params}`, { signal });
};
